import { Badge, Button, Card, Col, Row } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { allDevicesCustomer, getDataDevice } from '../Device/DeviceSlice';
import { allTenantDevices, tenantDeviceInfos } from './DashboardSlice';
import { useDispatch, useSelector } from 'react-redux';

import Breadcrumbs from '../../designs/Breadcrumbs/Breadcrumbs';
import CardMap from '../../components/CardMap/CardMap';
import { Edit } from 'react-feather';
import ModalChangeAvatarDevice from '../../components/Modal/ModalChangeAvatarDevice';
import PieChart from '../../components/Chart/PieChart';
import { Skeleton } from 'antd';
import defaultPicture from '../../assets/images/default_picture.png';
import { timestampToDate, timestampToDateAlert } from '../../common/handleTimestamp';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

export const disconnectThreshold = 60000; // 1 phút tính bằng mili giây
export const currentTime = Date.now();
let countOn = 0;
let countOff = 0;
const page = 0;
const pageSize = 1000;

const Dashboard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const token = localStorage.getItem('token');

  const [isChangeAvatar, setIsChangeAvatar] = useState(false);
  const [deviceIdPicked, setDeviceIdPicked] = useState('');

  const typeAcc = useSelector((state) => state.profile.profile.authority);
  const dataCustomer = useSelector((state) => state.profile.profile);
  const dashboardStatus = useSelector((state) => state.dashboard.status);
  const deviceStatus = useSelector((state) => state.device.status);

  // TENANT_ADMIN
  useEffect(() => {
    if (dashboardStatus === 'idle' && typeAcc === 'TENANT_ADMIN') {
      dispatch(tenantDeviceInfos({ token }));
    }
  }, [dispatch, dashboardStatus, typeAcc, token]);

  const tenantDevices = useSelector(allTenantDevices);

  // CUSTOMER
  const allDevices = useSelector(allDevicesCustomer);

  useEffect(() => {
    if (typeAcc !== 'TENANT_ADMIN') {
      const customerId = dataCustomer?.customerId?.id;
      if (customerId) {
        dispatch(getDataDevice({ token, customerId, pageSize, page }));
      }
    }
  }, [dispatch, token, dataCustomer, typeAcc]);

  const toAttributePage = (id) => {
    history.push(`/attribute/${id}`);
  };

  let containerList;
  let locationList;
  let loadingMap;
  let chartContent;

  function noData() {
    containerList = <Col md={3}>{t('no-data')}</Col>;
    loadingMap = <CardMap devices={[]} />;
    chartContent = <Col>{t('no-data')}</Col>;
  }

  // show alarm
  let arrAlarm = [];
  (typeAcc === 'TENANT_ADMIN' ? tenantDevices : allDevices)?.data?.map(
    (item) =>
      item.alarms?.length > 0 &&
      item.alarms?.map(
        (value) => value.status !== 'CLEARED_UNACK' && arrAlarm.push(value)
      )
  );
  let arrSortAlarm = arrAlarm.sort((a, b) => b.createdTime - a.createdTime);

  if (dashboardStatus === 'loading' || deviceStatus === 'loading') {
    containerList = <Skeleton active />;
    loadingMap = <Skeleton active />;
    chartContent = <Skeleton active />;
  } else if (dashboardStatus === 'success') {
    if (tenantDevices?.data.length > 0) {
      containerList = tenantDevices.data.map((item) => {
        let countAlert = 0;
        item?.alarms?.map(
          (value) => value.status !== 'CLEARED_UNACK' && countAlert++
        );
        return (
          <Col lg={3} md={4} sm={6} key={uuidv4()}>
            <Card
              className="card__device"
              id={countAlert > 0 ? `animationShadow` : ''}
            >
              <Card.Img
                variant="top"
                onClick={() => toAttributePage(item.id.id)}
                src={
                  item.attributes.avatar
                    ? item.attributes.avatar
                    : defaultPicture
                }
                style={{
                  height: '200px',
                  width: '100%',
                  objectFit: 'contain',
                }}
              />
              <Card.Body
                className="card__device-body"
                onClick={() => toAttributePage(item.id.id)}
              >
                <Row>
                  <Col className="card__device-text">
                    <Card.Title as="h6">{item.name}</Card.Title>
                    <Card.Text style={{ fontSize: '18px' }}>
                      {currentTime - item.attributes.lastActivityTime <=
                      disconnectThreshold ? (
                        <Badge pill bg="success" text="light">
                          {t('online')}
                        </Badge>
                      ) : (
                        <Badge pill bg="secondary" text="light">
                          {t('offline')}
                        </Badge>
                      )}
                    </Card.Text>
                    <div style={{ display: 'none' }}>
                      {currentTime - item.attributes.lastActivityTime <=
                      disconnectThreshold
                        ? countOn++
                        : countOff++}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Button
                onClick={() => {
                  setIsChangeAvatar(true);
                  setDeviceIdPicked(item.id.id);
                }}
                variant="primary"
                className="btn__changeAvatar"
                style={{}}
              >
                <Edit size={20} />
              </Button>
            </Card>
          </Col>
        );
      });
      // Get name, lat, long each device
      locationList = tenantDevices.data?.map((item) => ({
        name: item.name,
        longitude: item.attributes.longitude,
        latitude: item.attributes.latitude,
        image: item.attributes.avatar,
      }));
      loadingMap = <CardMap devices={locationList} />;
      chartContent = <PieChart countOff={countOff} countOn={countOn} />;
    } else noData();
  } else if (deviceStatus === 'idle') {
    if (allDevices.length > 0) {
      containerList = allDevices.map((item) => {
        return (
          <Col md={3} key={uuidv4()}>
            <Card
              className="card__device"
              id={item?.alarms?.length > 0 ? `animationShadow` : ''}
            >
              <Card.Img
                variant="top"
                onClick={() => toAttributePage(item.id.id)}
                src={
                  item.attributes.avatar
                    ? item.attributes.avatar
                    : defaultPicture
                }
                style={{
                  height: '200px',
                  width: '100%',
                  objectFit: 'contain',
                }}
              />
              <Card.Body
                className="card__device-body"
                onClick={() => toAttributePage(item.id.id)}
              >
                <Row>
                  <Col className="card__device-text">
                    <Card.Title as="h6">{item.name}</Card.Title>
                    <Card.Text style={{ fontSize: '18px' }}>
                      {currentTime - item.attributes.lastActivityTime <=
                      disconnectThreshold ? (
                        <Badge pill bg="success" text="light">
                          {t('online')}
                        </Badge>
                      ) : (
                        <Badge pill bg="secondary" text="light">
                          {t('offline')}
                        </Badge>
                      )}
                    </Card.Text>
                    <div style={{ display: 'none' }}>
                      {item.attributes.lastConnectTime >
                      item.attributes.lastDisconnectTime
                        ? countOn++
                        : countOff++}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Button
                onClick={() => {
                  setIsChangeAvatar(true);
                  setDeviceIdPicked(item.id.id);
                }}
                variant="primary"
                className="btn__changeAvatar"
              >
                <Edit size={20} />
              </Button>
            </Card>
          </Col>
        );
      });
      locationList = allDevices?.map((item) => {
        return {
          name: item.name,
          longitude: item.attributes.longitude,
          latitude: item.attributes.latitude,
          image: item.attributes.avatar,
        };
      });

      loadingMap = <CardMap devices={locationList} />;
      chartContent = <PieChart countOff={countOff} countOn={countOn} />;
    } else noData();
  }

  return (
    <section className="pcoded-main-container">
      <div className="pcoded-wrapper">
        <div className="pcoded-content">
          <div className="pcoded-inner-content">
            <div className="main-body">
              <div className="page-wrapper">
                <Breadcrumbs floor={[{ name: t('dashboard') }]} />
              </div>
              <Row>
                <Col lg={8} md={12}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <h5>{t('filter-station')}</h5>
                          <span className="d-block m-t-5">
                            {t('the-current')}{' '}
                            <code>{t('filter-station')}</code>{' '}
                            {t('the-list-container')}
                          </span>
                        </Card.Header>
                        <Card.Body>
                          <Row>{containerList}</Row>
                        </Card.Body>
                      </Card>
                    </Col>

                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <h5>{t('maps')}</h5>
                          <span className="d-block m-t-5">
                            {t('maps')} <code>{t('distribution')}</code>{' '}
                            {t('filter-station')}
                          </span>
                        </Card.Header>
                        <Card.Body style={{ zIndex: '0', height: '60vh' }}>
                          {' '}
                          {loadingMap}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>

                {/* chart */}
                <Col lg={4} md={12}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <h5>{t('alarm')}</h5>
                          <span className="d-block m-t-5">
                            {t('the-current')} <code>{t('alarm')}</code>{' '}
                            {t('the-list-container')}
                          </span>
                        </Card.Header>
                        <Card.Body style={{ zIndex: '0' }}>
                          {arrSortAlarm?.length > 0 ? (
                            arrSortAlarm?.map((value) => (
                              <div class="alert alert-warning">
                                <Link
                                  to={`/attribute/${value.originator.id}`}
                                  className="btn btn-warning"
                                >
                                  <i class="feather icon-alert-triangle"></i>
                                  {value.originatorName}
                                </Link>
                                {value.details}
                                <span class="badge badge-info">
                                  {timestampToDateAlert(value.createdTime)}
                                </span>
                              </div>
                            ))
                          ) : (
                            <p>{t('no-alarm')}</p>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>

                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <h5>{t('chart')}</h5>
                          <span className="d-block m-t-5">
                            {t('statistics')} <code>{t('status')}</code>{' '}
                            {t('filter-station')}
                          </span>
                        </Card.Header>
                        <Card.Body style={{ zIndex: '0' }}>
                          {chartContent}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <ModalChangeAvatarDevice
                show={isChangeAvatar}
                setShow={setIsChangeAvatar}
                deviceId={deviceIdPicked}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dashboard;
